import Link from 'next/link'

const ButtonLink = ({ children, uri }) => {
  return (
    <>
      <Link href={uri}>
        <a
          className={`px-4 py-2 mt-8 bg-white-lighter text-lg text-blue border-2 border-blue hover:bg-blue hover:text-white-light inline-block font-[sans-serif]`}
        >
          {children}
        </a>
      </Link>
    </>
  )
}

export default ButtonLink
